<splash class="splash" *ngIf="!stopLoading" id="splash"></splash>

<!-- <div class="box-img-error" *ngIf="gif">
  <div class="div-img-error">
  <img  src="assets/logo/logo-pedeaqui.png">
  </div>
</div> -->

<!-- <div *ngIf="!stopLoading && this.company">
  <img  [src]="this.company.company.logo" style="width: 100px;">
</div> -->


<div class="main" #main >
    <main class="main-container" #mainContainer [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </main>
    <app-bottom-menu *ngIf="this.bottomMenu"></app-bottom-menu>
</div>




